// flow weak

import React, {
  Component
}                         from 'react';
import PropTypes          from 'prop-types';
import {
  AnimatedView,
  StatsTable,
  MaterialList
}                         from '../../../components';
import styles                 from './style';
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../services/fetchTools';
import {Link} from 'react-router-dom';
import FlatButton from 'material-ui/FlatButton';
import styled from 'styled-components';
import { Spinner } from 'react-activity';

class VenueInfo extends Component {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      venue : this.props.venue,
      data:[],
      loading: true
    };
    this.handleBuddyClick = this.handleBuddyClick.bind(this);
  }

  componentWillMount() {
    const { actions: { enterPage } } = this.props;
    enterPage('Home');
  }

  componentDidMount() {
    this.getVenueDetails();
    // fetchEarningGraphDataIfNeeded();
    // fetchStatsCardDataIfNeeded();
    // fetchStatsTableDataIfNeeded();
  }

  componentWillUnmount() {
    const { actions: { leavePage } } = this.props;
    leavePage('Home');
  }

  getVenueDetails(){
    console.log('getVenueDetails')
    console.log('venue_id',this.state.venue)
    const url = `${getLocationOrigin()}/get_venue_list/get_venue_buddies/?venue=${this.state.venue}`;
    const options = {...defaultOptions};

    return fetch(url, options)
     .then(checkStatus)
     .then(parseJSON)
     .then(data => {
       if(data.success){
         this.setState({data:data.result,loading:false});
       }
       else{
        this.setState({loading:false})
        alert(data.message)
       }
     }).catch(error => error);
    }

  handleBuddyClick(event){
    const id = event.target.value
    window.location.href = `./#/crud/updateBuddy/${id}`
  }

  render() {
    console.log('venue',this.props)
    return(
      <div style={styles.container}>
        {this.state.loading === true ?
          <div style={{height:500}}>
            <div style={{  position: 'absolute',top: '50%',left: '50%',width: '100%',height: '100%'}}> <Spinner size="50" /></div>
          </div>
          :
          <div className='col-md-12'>
            <div className='col-md-12' style={{padding:'0px'}}>
              <div className='col-md-6' style={{marginTop:'1%'}}>
                <table className='table table-striped table-bordered table-hover'>
                  <tbody>
                    { this.state.data['Center Manager'] && this.state.data['Center Manager'].length > 1 ?
                      this.state.data['Center Manager'].map((cm,index)=>
                        <tr key={index} style={{marginBottom:'2%'}}>
                          <td className='col-md-2'> Center Manager {index + 1} </td>
                          <td className='col-md-2'> {cm.name} </td>
                          <td className='col-md-2'> <button className='button1' value={cm.id} onClick={this.handleBuddyClick}>Edit</button> </td>
                        </tr>
                        )
                      :
                      this.state.data['Center Manager'] &&
                        this.state.data['Center Manager'].map((cm,index)=>
                          <tr key={index}>
                            <td className='col-md-2'> Center Manager</td>
                            <td className='col-md-2'> {cm.name} </td>
                            <td className='col-md-2'> <button className='button1' value={cm.id} onClick={this.handleBuddyClick}>Edit</button> </td>
                          </tr>
                          )
                    }
                    { this.state.data['Desk Associate'] && this.state.data['Desk Associate'].length > 1 ?
                      this.state.data['Desk Associate'].map((da,index)=>
                        <tr key={index} style={{marginBottom:'2%'}}>
                          <td className='col-md-2'> Desk Associate {index + 1} </td>
                          <td className='col-md-2'> {da.name} </td>
                          <td className='col-md-2'> <button className='button1' value={da.id} onClick={this.handleBuddyClick}>Edit</button> </td>
                        </tr>
                        )
                      :
                      this.state.data['Desk Associate'] &&
                      this.state.data['Desk Associate'].map((da,index)=>
                        <tr key={index}>
                          <td className='col-md-2'> Desk Associate</td>
                          <td className='col-md-2'> {da.name} </td>
                          <td className='col-md-2'> <button className='button1' value={da.id} onClick={this.handleBuddyClick}>Edit</button> </td>
                        </tr>
                        )
                    }
                    { this.state.data['Lead Buddy'] && this.state.data['Lead Buddy'].length > 1 ?
                      this.state.data['Lead Buddy'].map((lb,index)=>
                        <tr key={index} style={{marginBottom:'2%'}}>
                          <td className='col-md-2'> Lead Buddy {index + 1} </td>
                          <td className='col-md-2'> {lb.name} </td>
                          <td className='col-md-2'> <button className='button1' value={lb.id} onClick={this.handleBuddyClick}>Edit</button> </td>
                        </tr>
                        )
                      :
                      this.state.data['Lead Buddy'] &&
                      this.state.data['Lead Buddy'].map((lb,index)=>
                        <tr key={index}>
                          <td className='col-md-2'> Lead Buddy</td>
                          <td className='col-md-2'> {lb.name} </td>
                          <td className='col-md-2'> <button className='button1' value={lb.id} onClick={this.handleBuddyClick}>Edit</button> </td>
                        </tr>
                        )
                    }
                    { this.state.data['Area Manager'] && this.state.data['Area Manager'].length > 1 ?
                      this.state.data['Area Manager'].map((am,index)=>
                        <tr key={index} style={{marginBottom:'2%'}}>
                          <td className='col-md-2'> Area Manager {index + 1} </td>
                          <td className='col-md-2'> {am.name} </td>
                          <td className='col-md-2'> <button className='button1' value={am.id} onClick={this.handleBuddyClick}>Edit</button> </td>
                        </tr>
                        )
                      :
                      this.state.data['Area Manager'] &&
                      this.state.data['Area Manager'].map((am,index)=>
                        <tr key={index}>
                          <td className='col-md-2'> Area Manager</td>
                          <td className='col-md-2'> {am.name} </td>
                          <td className='col-md-2'> <button className='button1' value={am.id} onClick={this.handleBuddyClick}>Edit</button> </td>
                        </tr>
                        )
                    }
                    { this.state.data['Trainer'] && this.state.data['Trainer'].length > 1 ?
                      this.state.data['Trainer'].map((am,index)=>
                        <tr key={index} style={{marginBottom:'2%'}}>
                          <td className='col-md-2'> Trainer {index + 1} </td>
                          <td className='col-md-2'> {am.name} </td>
                          <td className='col-md-2'> <button className='button1' value={am.id} onClick={this.handleBuddyClick}>Edit</button> </td>
                        </tr>
                        )
                      :
                      this.state.data['Trainer'] &&
                      this.state.data['Trainer'].map((am,index)=>
                        <tr key={index}>
                          <td className='col-md-2'> Trainer</td>
                          <td className='col-md-2'> {am.name} </td>
                          <td className='col-md-2'> <button className='button1' value={am.id} onClick={this.handleBuddyClick}>Edit</button> </td>
                        </tr>
                        )
                    }
                  </tbody>
                </table>
              </div>

              <div className='col-md-3' style={{margin:'1% 7%'}}>
                <table className='table table-striped table-bordered table-hover'>
                  <tbody>
                    <tr>
                        <th className='special-text' style={{textAlign:'center'}}> Amenities </th>
                      </tr>
                    { this.state.data.amenities && this.state.data.amenities.length > 0 ?

                      this.state.data.amenities.map((amenity,index)=>
                        <tr>
                          <td style={{textAlign:'center'}}> {amenity.value} </td>
                        </tr>
                        )
                      :
                      <tr>
                        <td style={{textAlign:'center'}}> No Amenities </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            </div>

            <div className='col-md-12 label_blue_1' style={styles.title}>
              Venue Images
            </div>

            <div className='col-md-12'>
              <div style={{marginTop:'2%'}} className="col-md-12">
                <div style={styles.item_header} className="col-md-6">
                    { this.state.data.images.picture ?
                    <img id="image3" src={this.state.data.images.picture} alt="Image 1" />
                    :
                    'No Images Available'
                    }
                </div>

                <div style={styles.item_header} className="col-md-6">
                    { this.state.data.images.picture_extra_1 ?
                    <img id="image3" src={this.state.data.images.picture_extra_1} alt="Image 2" />
                    :
                    ''
                    }
                </div>
              </div>

              <div style={{marginTop:'2%'}} className="col-md-12">
                <div style={styles.item_header} className="col-md-6">
                    { this.state.data.images.picture_extra_2 ?
                    <img id="image3" src={this.state.data.images.picture_extra_2} alt="Image 3" hei />
                    :
                    ''
                    }
                </div>

                <div style={styles.item_header} className="col-md-6">
                    { this.state.data.images.picture_extra_3 ?
                    <img id="image3" src={this.state.data.images.picture_extra_3} alt="Image 4" />
                    :
                    ''
                    }
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    );
  }
}

export default VenueInfo;



// WEBPACK FOOTER //
// ./src/app/views/centerportal/VenueInfo/VenueInfo.js